import { apiClient, ApiResponse } from './client'
import type {
  LcAdminRole, LcAdminRoleRequest, LcRoleListResponse,
  LcAccount, LcAccountCreateRequest, LcAccountUpdateRequest,
} from '@/types/rbac'

export const lcRolesApi = {
  getRoles: () =>
    apiClient.get<ApiResponse<LcRoleListResponse>>('/lc/admin/roles'),
  getPermissions: () =>
    apiClient.get<ApiResponse<string[]>>('/lc/admin/roles/permissions'),
  createRole: (data: LcAdminRoleRequest) =>
    apiClient.post<ApiResponse<LcAdminRole>>('/lc/admin/roles', data),
  updateRole: (id: number, data: LcAdminRoleRequest) =>
    apiClient.put<ApiResponse<LcAdminRole>>(`/lc/admin/roles/${id}`, data),
  deleteRole: (id: number) =>
    apiClient.delete<ApiResponse<void>>(`/lc/admin/roles/${id}`),
  cloneTemplate: (templateId: number) =>
    apiClient.post<ApiResponse<LcAdminRole>>(`/lc/admin/roles/from-template/${templateId}`),
}

export const lcAccountsApi = {
  list: () =>
    apiClient.get<ApiResponse<LcAccount[]>>('/lc/admin/accounts'),
  create: (data: LcAccountCreateRequest) =>
    apiClient.post<ApiResponse<LcAccount>>('/lc/admin/accounts', data),
  update: (userId: number, data: LcAccountUpdateRequest) =>
    apiClient.put<ApiResponse<LcAccount>>(`/lc/admin/accounts/${userId}`, data),
  delete: (userId: number) =>
    apiClient.delete<ApiResponse<void>>(`/lc/admin/accounts/${userId}`),
  resetPassword: (userId: number, newPassword?: string) =>
    apiClient.post<ApiResponse<{ temporaryPassword: string }>>(
      `/lc/admin/accounts/${userId}/reset-password`,
      { newPassword }
    ),
}
